import React, { useState, useEffect, useRef } from "react";
import "../../../StyleSheet/MainComponent/Role/RoleCreate.scss";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleCreateActions,
  setClientBranchActions, //--barnch
  setPerformanceAction,
  setTablePositionPersist,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Select from "react-select";
import { data } from "jquery";

import swal from "sweetalert2";
import Swal from "sweetalert2";
import useDebouncedEffect from "use-debounced-effect";

const RoleCreateForm = (props) => {
  const {
    setShow,
    show,
    currentPage,
    Datamonth,
    EMpRole,
    white_collar_List,
    search,
  } = props;
  console.log(currentPage, "sdf");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const Swal = require("sweetalert2");
  // console.log(EMpRole, "234234EMpRole");
  const initialState = {
    Role: "",
    perform_id: [],
    description: "",
    position_number: null,
    wages: "2",
    salary: "",
    clien_id: "",
    white_collar: EMpRole.value == "1" ? true : false,
    from_salary: "",
    to_salary: "",
    wbs_element: null,
    wbs_description: null,
  };
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );

  const [whiteChe, setWhiteChe] = useState("");
  const [datas, setDatas] = useState(initialState);
  const [RoleError, setRoleError] = useState("");
  const [wbs_elementerr, setWbserr] = useState("");
  const [wbsDexrip, setWbsDri] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [Performsid, setPerformId] = useState({ id: [] });
  const [options, setOptions] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [multiselectState, setMuliStateselect] = useState([]);
  const [projectErr, setProjectER] = useState("");
  const [nameList4, setOptions4] = useState([]);
  const initialStateSearch = {
    performsearhc: "",
    client: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    performsearhc: "",
    client: "",
  };
  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [performErr, setPerformmerr] = useState();
  const [clientErr, setClientErr] = useState();
  const [salarerr, setSalaerr] = useState();
  const [wagesErr, setWageErr] = useState();
  // console.log(datas, "23123datas", EMpRole.value, EMpRole.value == "1");
  ////---_Headers-----------------------------

  //---filter for Skill Assement Headers--------
  const [typeOfParent, setEmplyHeaders] = useState([
    {
      value: "Tech",
      label: "TECHNICAL",
    },
    {
      value: "soft",
      label: "SOFT SERVICES",
    },
  ]);

  const [EMpHeaderSelected, setEmpHeadersSele] = useState(typeOfParent[0]);

  const [typeOfperformance, setPerformances] = useState("Tech");
  const [from_salaryErro, seyFromsalaryerr] = useState("");
  const [tosalaryErr, settosalaryErr] = useState("");
  const [vefied, setverified] = useState(0);

  ////----\Header--changes---
  const HandleHeaderrole = (e) => {
    if (e != null) {
      setEmpHeadersSele(e);
      setPerformances(e.value);

      if (
        e.value == "Tech" &&
        state.performanceTypeCall.performanceDatas != undefined
      ) {
        let objectArray = [];
        let ids = [];

        state.performanceTypeCall.performanceDatas.forEach((element) => {
          element.parent_type == "Tech" &&
            objectArray.push({
              value: element.id,
              label: element.grading_name,
            });

          element.parent_type == "Tech" && ids.push(element.id);
        });
        setMuliStateselect(objectArray);

        setOptions(objectArray);
        setDatas({
          ...datas,
          perform_id: ids,
        });
      }

      if (
        e.value == "soft" &&
        state.performanceTypeCall.performanceDatas != undefined
      ) {
        let objectArray = [];

        let ids = [];

        state.performanceTypeCall.performanceDatas.forEach((element) => {
          element.parent_type == "soft" &&
            objectArray.push({
              value: element.id,
              label: element.grading_name,
            });

          element.parent_type == "soft" && ids.push(element.id);
        });
        setOptions(objectArray);
        setMuliStateselect(objectArray);
        setDatas({
          ...datas,
          perform_id: ids,
        });
      }
    }
  };

  //console.log(datas.white_collar , "white_collar");
  const [whitechanges, setwhitechnages] = useState(true);

  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "0",
      label: "UDS",
    },
    {
      value: "1",
      label: "CLIENT",
    },
  ]);
  const [EMpROleSelected, setEmpRoleSele] = useState([
    // EMpRole.value != "" ? EMpRole : EmpRoles[0],
    EMpRole.value == "1" ? EmpRoles[0] : EmpRoles[1],
  ]);

  const inputRef = useRef(null);
  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, "");

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      if (e.value == 0) {
        setDatas({
          ...datas,
          white_collar: true,
          clien_id: null,
          perform_id: [],
        });
      } else {
        setDatas({
          ...datas,
          white_collar: false,
        });
      }
    }
  };
  const [wagetype, setwages] = useState([
    {
      value: "0",
      label: "DAILY",
    },
    {
      value: "1",
      label: "WEEKLY",
    },

    {
      value: "2",
      label: "MONTHLY",
    },
  ]);

  const [Wagevalue, setwageval] = useState(wagetype[2]);

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          performsearhc: SearchDebounance.performsearhc,
          client: SearchDebounance.client,
        });
      }
    },
    500,
    [SearchDebounance],
  );
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      performsearhc: Val,
    });
  };

  const handleInputChangeClinet = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      client: Val,
    });
  };

  const handleClose = () => {
    Swal.fire({
      title: `Do you want to exit?`,
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  const HandleChanges = (e, values) => {
    if (e.target.name == "white_collar") {
      const { name, value } = e.target;
      setDatas({
        ...datas,
        [name]: values,
      });
    } else if (e.target.name != "white_collar") {
      const { name, value } = e.target;
      setDatas({
        ...datas,
        [name]: value,
      });
    }
    if (e.target.name == "salary") {
      const { name, value } = e.target;

      setDatas({
        ...datas,
        salary: value,
        from_salary:
          datas.wages == 0
            ? value * 31
            : datas.wages == 1
              ? Math.round((value / 7) * 31)
              : value,
      });

      // console.log(datas.wages ,"w72387384723" ,datas.wages ==0 ? datas.wages *31 : datas.wages == 1 ? Math.round((e.target.value /7) *31) : e.target.value );
    }

    // datas.wages == 0 meands its dails , if its 1 means weekly , or else monthly
  };

  ///---Performs0----
  useEffect(() => {
    const payload = {
      search: SearchedVal.performsearhc,
      page_size: 100,
      page: 1,
    };
    dispatch(setPerformanceAction(payload));
  }, [show, SearchedVal.performsearhc]);

  useEffect(() => {
    const payload = {
      search: SearchedVal.client,
      page_size: 10,
      page: 1,
      client: "",
    };
    dispatch(setClientBranchActions(payload));
  }, [SearchedVal.client]);

  //----Options---
  useEffect(() => {
    if (state.performanceTypeCall.performanceDatas != undefined) {
      let objectArray = [];
      let ids = [];

      state.performanceTypeCall.performanceDatas.forEach((element) => {
        element.parent_type == "Tech" &&
          objectArray.push({
            value: element.id,
            label: element.grading_name,
          });

        element.parent_type == "Tech" && ids.push(element.id);
      });
      setOptions(objectArray);
      setDatas({
        ...datas,
        perform_id: ids,
      });

      setMuliStateselect(objectArray);
    }
  }, [state.performanceTypeCall.performanceDatas, SearchedVal.performsearhc]);

  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client]);

  ///---Changer----
  const handlePerform = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    let ids = [];

    setMuliStateselect(selectedVal);

    for (let i = 0; i < selectedVal.length; i++) {
      ids.push(selectedVal[i].value);
    }
    setDatas({
      ...datas,
      perform_id: ids,
    });
    // setPerformId({ ...Performsid, id: selectedVal.value });
    // console.log(ids, "ids");
  };
  // console.log(Performsid, "Performsid", datas);
  const HandleClientBranches = (selectedVal) => {
    console.log(selectedVal.value, "va;lusfodcn ");

    setDatas({
      ...datas,
      clien_id: selectedVal.value,
    });
  };
  const Handlewages = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    setwageval(selectedVal);
    setDatas({
      ...datas,
      wages: selectedVal.value,
      salary: datas.salary,
      from_salary:
        selectedVal.value == 0
          ? datas.salary * 31
          : selectedVal.value == 1
            ? Math.round((datas.salary / 7) * 31)
            : datas.salary,
    });
  };

  const HandleSubmit = () => {
    // console.log(datas);

    var a = 0;
    console.log(a == 0, vefied == 0, datas, "39749237489273");
    if (datas.Role == "") {
      a = 1;
      setRoleError("*Designation is required");
    }
    if (datas.description == "") {
      a = 1;
      setDescriptionError("*Descriptions is required");
    }
    // if (datas.perform_id == "") {
    //   setPerformmerr("*Perform is required");
    //   a = 1;
    // }

    if (datas.salary == "") {
      setSalaerr("*Salary is required");
      a = 1;
    }

    if (datas.white_collar == false) {
      if (datas.from_salary == "") {
        seyFromsalaryerr("*From salary is required");
        a = 1;
      }
      if (datas.to_salary == "") {
        settosalaryErr("*To salary is required");
        a = 1;
      }
    }
    if (datas.white_collar == false) {
      if (datas.clien_id == "") {
        setClientErr("*client branch is required");
        a = 1;
      }
      //  / if (datas.wbs_element == "") {
      //   setWbserr("*Wbs Element is required");
      //   a = 1;
      // }

      // if (datas.wbs_description == "") {
      //   setWbsDri("*Wbs Description is required");
      //   a = 1;
      // }
    }
    if (datas.wages == "") {
      setWageErr("*Wages Type is required");
      a = 1;
    }
    //  if(datas.white_collar == ""){
    //  a = 1;
    //  setWhiteChe("* Onboarding is required")

    //  }
    // if (datas.position_number == "") {
    //   a = 1;

    //   setProjectER("*Position Number is required");
    // }
    if (a == 0 && vefied == 0) {
      console.log(datas, "inner");

      Swal.fire({
        title: `Do you want to create Designation ?`,
        // text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          const newEntry = { updated: true };
          const result = {
            ...TablePositionPersist.DesginationStates,
            ...newEntry,
          };

          dispatch(
            setTablePositionPersist({
              data: result,
              pageName: "DesginationStates",
            }),
          );

          const payload = {
            datas: datas,
            currentPage: currentPage,
            white_collar: state.NumberCounts.Rolechanges == 1 ? true : false,
            month: Datamonth.month,
            year: Datamonth.year,
            white_collar_List: white_collar_List,
            search: search,
          };
          dispatch(getRoleCreateActions(payload, props.setShow()));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
        <div className="col BodyContent">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div class="ModalHeader">
                      <span className="UserCreate"> Designation </span>

                      <div
                        className="CloseIcon"
                        onClick={(e) => handleClose(e)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>

                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div class="col-sm-3 mt-3">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Employee Designation
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          {/* <input
                            type="checkbox"
                            //value={"true"}
                            style={{ marginLeft: "15px" }}
                            name="white_collar"
                            // class="form-control"
                            // autoComplete="off"
                            // value={datas.white_collar}
                            onChange={(e) => {
                              setwhitechnages(!whitechanges);
                              HandleChanges(e, whitechanges);
                              setWhiteChe("");
                            }}
                            checked={datas.white_collar}
                          ></input> */}

                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              HandleEMprole(e);
                              setWhiteChe("");
                            }}
                            value={EMpROleSelected}
                            options={EmpRoles}
                            placeholder="search"
                          />

                          <p style={{ color: "red", marginTop: "5px" }}>
                            {whiteChe}
                          </p>
                        </div>

                        <div class="col-sm-3  mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Designation
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={datas.Role}
                            autoComplete="off"
                            onChange={(e) => {
                              HandleChanges(e);
                              setRoleError("");
                            }}
                            required
                            name="Role"
                            style={{
                              padding: "10px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {RoleError}
                          </p>
                        </div>
                        <div class="col-sm-3 mt-3 ">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Position Number
                            {/* <span style={{ color: "red" }}>*</span> */}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autoComplete="off"
                            value={
                              datas.position_number != null &&
                              datas.position_number != ""
                                ? datas.position_number.slice(0, 20)
                                : datas.position_number
                            }
                            onChange={(e) => {
                              HandleChanges(e);
                              if (e.target.value.length > 20) {
                                setProjectER(
                                  "*Project Number should not exit 20 characters",
                                );
                              } else {
                                setProjectER("");
                              }
                            }}
                            name="position_number"
                            required
                            style={{
                              padding: "10px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {projectErr}
                          </p>
                        </div>
                        {!datas.white_collar ? (
                          <>
                            <div class="col-sm-3  mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                                style={{ fontSize: "15px" }}
                              >
                                Wbs Element
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={datas.wbs_element}
                                autoComplete="off"
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setWbserr("");
                                }}
                                required
                                name="wbs_element"
                                style={{
                                  padding: "10px",
                                }}
                              ></input>
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {wbs_elementerr}
                              </p>
                            </div>

                            <div class="col-sm-3  mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                                style={{ fontSize: "15px" }}
                              >
                                Wbs Description
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={datas.wbs_description}
                                autoComplete="off"
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setWbsDri("");
                                }}
                                required
                                name="wbs_description"
                                style={{
                                  padding: "10px",
                                }}
                              ></input>
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {wbsDexrip}
                              </p>
                            </div>
                          </>
                        ) : null}
                        {/* </div>
                      <div className="row"> */}
                        <div className="col-sm-3  mt-3 WagesType">
                          <label for="validationCustom01" class="form-label">
                            Wages Type
                          </label>
                          <span style={{ color: "red" }}>*</span>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              Handlewages(e);
                              setWageErr("");
                            }}
                            options={wagetype}
                            placeholder="search"
                            value={Wagevalue}
                          />
                          <p
                            style={{
                              color: "red",
                              marginTop: "5px",
                              marginLeft: "2px",
                            }}
                          >
                            {wagesErr}
                          </p>
                        </div>

                        <div class="col-sm-3 mt-3">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Salary
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            autoComplete="off"
                            value={datas.salary}
                            // onChange={(e) => {
                            //   // HandleChanges(e);
                            //   // setSalaerr("");

                            //   HandleChanges(e);
                            //   if (e.target.value.length > 20) {
                            //     setSalaerr("*Salary should not exceed 20 digits");
                            //     setverified(1)
                            //   } else {
                            //     setSalaerr("");
                            //     setverified(0)
                            //   }

                            //   // setDatas({
                            //   //   ...datas,
                            //   //   from_salary:
                            //   //     datas.wages == 0
                            //   //       ? datas.wages * 31
                            //   //       : datas.wages == 1
                            //   //       ? Math.round((e.target.value / 7) * 31)
                            //   //       : e.target.value,
                            //   // });
                            // }}

                            onChange={(e) => {
                              const inputValue = parseFloat(e.target.value);
                              if (inputValue <= 0) {
                                setSalaerr("*salary must be greater than 0.");
                                setverified(1);
                                e.target.value = "";
                              } else {
                                setSalaerr("");
                                setverified(0);
                                HandleChanges(e);
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = parseFloat(e.target.value);
                              if (inputValue <= 0) {
                                setSalaerr("*salary must be greater than 0.");
                                setverified(1);
                                e.target.value = "";
                              } else {
                                setSalaerr("");
                                setverified(0);
                                HandleChanges(e);
                              }
                            }}
                            step="1"
                            onKeyDown={preventZoom}
                            onPaste={handlePaste}
                            onWheel={preventZoom}
                            ref={inputRef}
                            name="salary"
                            required
                            style={{
                              padding: "10px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {salarerr}
                          </p>
                        </div>

                        {!datas.white_collar ? (
                          <div
                            className="col-sm-3"
                            style={{ marginTop: "-15px", marginBottom: "10px" }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ marginTop: "7px" }}
                              >
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Salary
                                </label>
                                <span style={{ color: "red" }}>*</span>
                              </div>
                              <div
                                className="row"
                                style={{
                                  marginLeft: "5px",
                                  display: "flex",
                                  marginRight: "2px",
                                }}
                              >
                                <div className="col-sm-6">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    From
                                  </label>

                                  <input
                                    type="number"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="from_salary"
                                    value={datas.from_salary}
                                    // onChange={(e) => {
                                    //   HandleChanges(e);
                                    //   seyFromsalaryerr("");
                                    // }}

                                    onChange={(e) => {
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        seyFromsalaryerr(
                                          "* From salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        seyFromsalaryerr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    onInput={(e) => {
                                      if (e.target.value.length > 15) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          15,
                                        );
                                      }
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        seyFromsalaryerr(
                                          "* From salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        seyFromsalaryerr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    step="1"
                                    onKeyDown={preventZoom}
                                    onPaste={handlePaste}
                                    onWheel={preventZoom}
                                    ref={inputRef}
                                  />
                                  <p className="Error">{from_salaryErro}</p>
                                </div>

                                <div className="col-sm-6">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    To
                                  </label>
                                  <input
                                    type="number"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="to_salary"
                                    value={datas.to_salary}
                                    // onChange={(e) => {
                                    //   HandleChanges(e);
                                    //   settosalaryErr("");
                                    // }}
                                    // onChange={(e) => {
                                    //   HandleChanges(e);
                                    //   const toSalary = e.target.value;
                                    //   const fromSalary = datas.from_salary;
                                    //   settosalaryErr("");
                                    //   // if (toSalary < fromSalary) {
                                    //   //   setverified(1)

                                    //   //   settosalaryErr("*To Salary should not be less than From Salary");
                                    //   // } else {
                                    //   //   settosalaryErr("");
                                    //   //   setverified(0)

                                    //   // }

                                    // }}

                                    onChange={(e) => {
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        settosalaryErr(
                                          "*To salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        settosalaryErr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    onInput={(e) => {
                                      if (e.target.value.length > 15) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          15,
                                        );
                                      }
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        settosalaryErr(
                                          "*To  salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        settosalaryErr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    step="1"
                                    onKeyDown={preventZoom}
                                    onPaste={handlePaste}
                                    onWheel={preventZoom}
                                    ref={inputRef}
                                  />

                                  <p className="Error">{tosalaryErr}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {!datas.white_collar ? (
                          <div className="col-sm-3 field-div">
                            <label for="validationCustom01" class="form-label">
                              Client Name
                            </label>
                            <span style={{ color: "red" }}>*</span>
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleClientBranches(e);
                                setClientErr("");
                              }}
                              options={nameList4}
                              onInputChange={handleInputChangeClinet}
                              placeholder="search"
                            />
                            <p
                              style={{
                                color: "red",
                                marginTop: "5px",
                                marginLeft: "2px",
                              }}
                            >
                              {clientErr}
                            </p>
                          </div>
                        ) : null}

                        {datas.white_collar == false ? (
                          <div className="col-sm-3 field-div">
                            <label htmlFor="points">
                              Type of Header
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleHeaderrole(e);
                              }}
                              value={EMpHeaderSelected}
                              options={typeOfParent}
                              placeholder="search"
                            />
                          </div>
                        ) : null}

                        {datas.white_collar == false ? (
                          <>
                            {" "}
                            <div class="col-sm-3  field-div" id="RoleCreate">
                              <label
                                for="validationCustom02"
                                class="form-label"
                                style={{ fontSize: "15px", marginTop: "15px" }}
                              >
                                Performance
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              {/* <div className="Performance"> */}
                              <Select
                                className="Selects"
                                style={{
                                  fontSize: "12px",
                                  margin: "auto",
                                  chips: {
                                    background: "#4D9BD7",
                                    borderRadius: "3px",
                                  },
                                  option: {
                                    color: "black",
                                    backgroundColor: "white",
                                  },
                                  inputField: {
                                    margin: "-5px 5px",
                                    height: "40px",
                                  },
                                  searchBox: {
                                    padding: "5px",
                                    height: "70px",
                                    overflow: "auto",
                                  },
                                }}
                                onSelect={(e) => setMuliStateselect(e)}
                                onChange={(e) => {
                                  handlePerform(e);
                                  setPerformmerr("");
                                }}
                                isMulti
                                options={options}
                                onInputChange={handleInputChange}
                                labelledBy="Select"
                                value={multiselectState}
                              />
                              {/* </div> */}
                            </div>
                            <p
                              style={{
                                color: "red",
                                // marginTop: "5px",
                                // marginLeft: "2px",
                              }}
                            >
                              {performErr}
                            </p>
                          </>
                        ) : null}

                        <div class="col-sm-3 field-div">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Description
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            autoComplete="off"
                            value={datas.description}
                            onChange={(e) => {
                              HandleChanges(e);
                              setDescriptionError("");
                            }}
                            name="description"
                            required
                            style={{
                              padding: "10px",
                              height: "60%",
                            }}
                          ></textarea>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {DescriptionError}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="RoleButton"
                      style={{
                        display: "flex",
                        gap: "15px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        // marginTop: "20px",
                        padding: "20px",
                      }}
                    >
                      <button
                        class="btn  CancelBtn ButtonCSS"
                        type="submit"
                        onClick={HandleSubmit}
                      >
                        Submit
                      </button>

                      <button
                        class="btn CancelBtn ButtonCSS"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleCreateForm;
